import { withNamespaces } from 'react-i18next'
import { connect } from 'react-redux'
import axios from 'axios'
import Spinner from 'react-bootstrap/Spinner'
import { toast } from 'react-toastify'
import { useCallback, useState } from 'react'
import { API_BASE_URL } from 'src/modules/data-protection/constants'

const ExportExcelButton = ({ 
    t, 
    token,
    filters
}) => {
    const [downloadOptions, setDownloadOptions] = useState({
        percent: 0,
        status: null,
        cancelToken: null
    })

    const downloadExcel = useCallback(async ({
        payload,
        onDownloadProgress, 
        cancelToken
    }) => {
        return axios.post(
            `${API_BASE_URL}/report_case/download`,
            payload,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${token}`
                },
                onDownloadProgress: onDownloadProgress,
                cancelToken: cancelToken
            }
        )
    }, [ token ])

    const handleExport = async () => {
        if(downloadOptions.status === 'downloading') return;

        const cancelToken = axios.CancelToken.source()

        setDownloadOptions({
            percent: 0,
            status: 'downloading',
            cancelToken: cancelToken
        })

        let loadedBytes = 0

        try {
            const response = await downloadExcel({
                payload: {
                    ...filters,
                    questionnaire: 'data_subject_request',
                    pageIndex: undefined,
                    pageSize: undefined
                },
                onDownloadProgress: (progressEvent) => {
                    loadedBytes = progressEvent.loaded

                    const percentCompleted = Math.round(
                        (loadedBytes * 100) / progressEvent.total
                    )

                    setDownloadOptions((currentState) => {
                        return {...currentState, percent: percentCompleted}
                    })
                },
                cancelToken: cancelToken.token
            })
    
            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: '*' })
            )

            const link = document.createElement('a')
    
            link.href = url
            link.setAttribute('download', 'data_subject_requests.xlsx')
    
            document.body.appendChild(link)
    
            link.click()
            link.remove()

            setDownloadOptions({
                percent: 0,
                status: 'finished',
                cancelToken: null
            })
        } 
        catch (error) {
            let status;
            if (axios.isCancel(error)) {
                status = 'canceled'
                toast(t('Download cancelled.'), {
                    type: 'success',
                })
            } 
            else {
                status = 'faild'
                toast(t('An error occurred while downloading the file.'), {
                    type: 'error'
                })
            }

            setDownloadOptions({
                percent: 0,
                status: status,
                cancelToken: null
            })
        }
    }

    return (
        <div
            onClick={handleExport}
        >
            {downloadOptions.status === 'downloading' ? (
                <>
                    <Spinner
                        animation='border'
                        size='sm'
                        className='me-1'
                    />
                    {t('Exporting')}{` ${downloadOptions.percent}%`}
                    
                </>
            ) : (
                <>
                    <i className='ri-download-line align-middle me-1' />
                    {t(
                        'Export as Excel'
                    )}
                </>
            )}
        </div>
    )
}

const mapToState = (state) => {
    const { token } = state.Login

    return {
        token
    }
}

export default withNamespaces()(
    connect(mapToState, {})(
        ExportExcelButton
    )
)
